module.exports = __webpack_public_path__ + "static/media/DisableOrganizationIcon.97317514.svg";